import React from 'react';
import Slider from 'react-slick';

const clients = [
  { name: 'Grupo Tech Track', logo: '/images/clients/cliente1.png' },
  { name: 'Save Auto', logo: '/images/clients/cliente2.png' },
  { name: 'Just', logo: '/images/clients/cliente3.png' },
  { name: 'JN', logo: '/images/clients/cliente4.png' },
  { name: 'Master Jet', logo: '/images/clients/cliente5.png' },
  { name: 'Proseg', logo: '/images/clients/cliente6.png' },
  { name: 'Mavers', logo: '/images/clients/cliente7.png' },
  { name: 'Mix', logo: '/images/clients/cliente8.png' },
  { name: 'Sirius', logo: '/images/clients/cliente9.png' },
  { name: 'Tech track Macapá', logo: '/images/clients/cliente10.png' },
  { name: 'upeat restaurante', logo: '/images/clients/cliente11.png' },
  { name: 'Help tech', logo: '/images/clients/cliente12.png' },

];

const ClientsCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section id="clients" className="py-10 md:py-20 bg-gray-100 text-gray-800">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-10">Alguns de Nossos Clientes</h2>
        <Slider {...settings}>
          {clients.map((client, index) => (
            <div key={index} className="p-4">
              <img 
                src={client.logo} 
                alt={client.name} 
                className="mx-auto mb-4 max-h-32" 
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default ClientsCarousel;
